import logger from '../../log';
import { NonStdPlayerEvents } from '../../common/Reporter/constants';
import { dispatchPlayerEvent } from '../../events/dispatch';
import { CleanupMethod } from '../BaseInteraction';
import { HLSEventCallback } from '@kollective-frontend/ksdk-api';
const log = logger.getLogger(__filename);

export const HLS_LEVEL_SWITCHING = 'hlsLevelSwitching';

export interface HlsLevelSwitchingData {
  bitrate: number;
}

type HlsEventHandler = (e: string, item: unknown) => void;

export interface HLSjsEventListenerObject {
  on: (name: string, handler: HLSEventCallback) => void;
  off: (name: string, handler?: HLSEventCallback) => void;
  once: (name: string, handler: HLSEventCallback) => void;
}

const attachHlsEvents = (hls: HLSjsEventListenerObject): CleanupMethod => {
  if (typeof hls.on !== 'function') {
    log.warn('Unable to set up HLS event handlers. Missing "on" function');
    return () => undefined;
  }
  const e = NonStdPlayerEvents.playbackbitratechanged.code;
  const handlers: Map<string, HlsEventHandler> = new Map();
  handlers.set(HLS_LEVEL_SWITCHING, (_event: string, item: unknown) => {
    const data = item as HlsLevelSwitchingData;
    dispatchPlayerEvent({ e, b: data.bitrate });
  });
  handlers.forEach((handler, name) => {
    hls.on(name, handler);
  });
  return () => {
    if (hls.off) {
      handlers.forEach((handler, name) => {
        hls.off(name, handler);
      });
    }
    handlers.clear();
  };
};

export default attachHlsEvents;
